import { Body, Button, FlexBox, Message } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';

const AfcAuthFailureBanner = () => {
	const { t } = useTranslation(['signup']);

	const retryAfcSignIn = () => {
		Router.push({ pathname: '/sign_in', query: { mode: 'afc' } });
	};

	return (
		<Message iconName="info" color="brand" iconColor="brand" borderColor="brand">
			<FlexBox flexDirection="column" gap="sm" alignItems="flex-start">
				<Body>{t('signup:steps.step0.afcAuthFailureRetry.message')}</Body>
				<Button variant="tertiary" size="smaller" onClick={retryAfcSignIn}>
					{t('signup:steps.step0.afcAuthFailureRetry.cta')}
				</Button>
			</FlexBox>
		</Message>
	);
};

export default AfcAuthFailureBanner;
